<i
  class="ngx-gallery-icon {{ icon }}"
  [class.ngx-gallery-icon-disabled]="disabled"
  aria-hidden="true"
  title="{{ titleText }}"
  (click)="handleClick($event)"
>
</i>
